import css from 'styled-jsx/css';

const styles = css.global`#emp-garantia-carro-mais-longe {
  padding: 40px 0;
  overflow: hidden;
}

#emp-garantia-carro-mais-longe .ctn-home-24 {
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
}

#emp-garantia-carro-mais-longe .mais-longe-imagens {
  position: relative;
  max-width: 290px;
}

#emp-garantia-carro-mais-longe .mais-longe-iphone {
  width: 100%;
  max-width: 287px;
  height: auto;
}

#emp-garantia-carro-mais-longe .mais-longe-img-proposta {
  width: 144px;
  position: absolute;
  right: -27px;
  bottom: 48px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  height: auto;
}

#emp-garantia-carro-mais-longe .mais-longe-titulo {
  margin: 0;
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}

#emp-garantia-carro-mais-longe .mais-longe-cards {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

#emp-garantia-carro-mais-longe .mais-longe-cards .mais-longe-card {
  display: flex;
  align-items: center;
  gap: 16px;
}

#emp-garantia-carro-mais-longe .mais-longe-card .mais-longe-card-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#emp-garantia-carro-mais-longe .mais-longe-btn-simular {
  width: 100%;
  max-width: 272px;
  height: 48px;
  margin: 32px auto 0;
}

.emp-garantia-carro-img-separacao {
  width: 100%;
  height: 319px;
  object-fit: cover;
  object-position: top;
}

@media (min-width: 992px) {
  #emp-garantia-carro-mais-longe {
    padding: 80px 0;
  }

  #emp-garantia-carro-mais-longe .ctn-home-24 {
    align-items: flex-end;
    position: relative;
  }

  #emp-garantia-carro-mais-longe .mais-longe-imagens {
    position: absolute;
    left: -40px;
    top: -43px;
    width: 50%;
    max-width: 526px;
  }

  #emp-garantia-carro-mais-longe .mais-longe-textos {
    width: 50%;
    max-width: 629px;
  }

  #emp-garantia-carro-mais-longe .mais-longe-iphone {
    max-width: 526px;
  }
  
  #emp-garantia-carro-mais-longe .mais-longe-img-proposta {
    width: 200px;
    right: -33px;
    bottom: 187px;
  }

  #emp-garantia-carro-mais-longe .mais-longe-titulo {
    font-size: 40px;
    line-height: 60px;
  }
  
  #emp-garantia-carro-mais-longe .mais-longe-cards {
    margin-top: 24px;
  }
  
  #emp-garantia-carro-mais-longe .mais-longe-cards .mais-longe-card {
    gap: 24px;
  }
  
    #emp-garantia-carro-mais-longe .mais-longe-btn-simular {
    width: 100%;
    max-width: 272px;
    height: 48px;
    margin: 32px 0 0;
  }
}`;

export default styles;